import {useEffect} from "react";

// Each mounted consumer owns a link so overlapping screens cannot unload each other's font.
export const usePrintoutFontStylesheet = (fontUrl?: string) => {
    useEffect(() => {
        const url = fontUrl?.trim();

        if (!url || !/^https?:\/\//i.test(url)) return;

        const link = document.createElement("link");
        link.rel = "stylesheet";
        link.href = url;
        document.head.appendChild(link);

        return () => {
            link.remove();
        };
    }, [fontUrl]);
};
